//import AsyncLocalStorage from '@createnextapp/async-local-storage'
import { allconfig } from '../config'
import { getData } from './request';


  export const getAPIBaseURL = () => {
    var api_base_url = allconfig.env == "dev" ? allconfig.dev_api_url : allconfig.prod_api_url

    return api_base_url;
  }

  export const getSiteBaseURL = () => {
    var site_base_url = allconfig.env == "dev" ? allconfig.dev_site_url : allconfig.prod_site_url
  
    return site_base_url;
  }

  export const getLandingURL = () => {
    var site_base_url = allconfig.env == "dev" ? allconfig.dev_site_url : allconfig.prod_landing_url
  
    return site_base_url;
  }

  export const getUser = () => {
    try {
      const raw = localStorage.getItem('user')
      // Handle cases where the value is missing or was stored as the literal string "undefined"/"null"
      if (!raw || raw === 'undefined' || raw === 'null') {
        return null
      }
      return JSON.parse(raw)
    } catch (error) {
      // If parsing fails for any reason, treat as logged out
      console.error('Failed to parse user from localStorage', error)
      return null
    }
  }
  
  export const isLoggedUnsecuredToken = () => {
    const token = localStorage.getItem('token')
    const user = localStorage.getItem('user')
    const settings = localStorage.getItem('settings')
    if (!token || !user || !settings) {
      return false
    }

      const decodedJwt = parseJwt(token)
    if (!decodedJwt || !decodedJwt.exp) {
      return false
    }

    // consider user logged in if token is not expired
    return !(decodedJwt.exp * 1000 < Date.now())
  }

  export const isLogged = () => {
    const user = getUser()
    const admin = getAdmin()
    // User or admin logged in (cookie-based auth, so just check if user/admin data exists)
    return !!(user || admin)
  }

  

  const parseJwt = (token) => {
    try{
      return JSON.parse(window.atob(token.split(".")[1]))
    }catch(error){
      return null
    }  
  }

  export const checkTokenExpiration = () => {
    const token = localStorage.getItem('token')
    if(!token) {
      // Check if admin is logged in
      const admin = getAdmin()
      if (admin) {
        // Admin uses cookie-based auth, verify by making a test API call
        verifyAdminToken()
      }
      return false
    }
    
    const decodedJwt = parseJwt(token)
    if(!decodedJwt || !decodedJwt.exp) {
      // Check if admin is logged in
      const admin = getAdmin()
      if (admin) {
        verifyAdminToken()
      }
      return false
    }
    
    // Check if token is expired (with 5 second buffer)
    const expirationTime = decodedJwt.exp * 1000
    const currentTime = Date.now()
    
    if(expirationTime <= currentTime) {
      // Token expired, logout
      logout()
      return true
    }
    
    return false
  }

  // Verify admin token by making a lightweight API call
  export const verifyAdminToken = async () => {
    try {
      const admin = getAdmin()
      if (!admin) {
        return false
      }

      // Make a lightweight API call to verify token (using admins endpoint as it's admin-specific)
      const url = `${getAPIBaseURL()}/v1/admins`
      const token = localStorage.getItem('token')
      const headers = token ? { 'token': token } : {}
      
      // Use fetch directly to avoid circular dependency with request.js
      const response = await fetch(`${url}?limit=1`, {
        method: 'GET',
        headers: {
          ...headers,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      })
      
      // If we get a successful response, token is valid
      if (response.status === 200) {
        return true
      }
      
      // If 401, token is invalid or expired
      if (response.status === 401) {
        return false
      }
      
      return true
    } catch (error) {
      // If error, assume token is invalid
      console.error('Admin token verification failed:', error)
      return false
    }
  }

  export const checkAdminTokenExpiration = async () => {
    const admin = getAdmin()
    if (!admin) {
      // No admin found, logout
      adminLogout()
      return true
    }

    // Verify token by making a lightweight API call
    const isValid = await verifyAdminToken()
    if (!isValid) {
      // Token expired/invalid, logout
      adminLogout()
      return true
    }
    
    return false
  }
  
  export const logout = () => {
    localStorage.removeItem("user");
    sessionStorage.removeItem("active");
    window.location.href = `${getSiteBaseURL()}/login`
  }

  export const dataURLtoBlob = (dataURL) => {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });
    return blob;
  }

  export const formatToWordsDate = (dateString) => {
    const date = new Date(dateString);
    const formatedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

  return formatedDate
}

export const getAdmin = () => {
  try {
    const admin = localStorage.getItem('admin')
    if(admin && admin !== 'undefined' && admin !== 'null'){
      return JSON.parse(admin)
    }else{
      return null
    }
  } catch (error) {
    console.error('Failed to parse admin from localStorage', error)
    return null
  }
}

export const isAdminLogged = () => {
  let logged = false
  const admin = getAdmin()
  if(admin){
    const adminSession = sessionStorage.getItem('admin-active')
    if(adminSession){
      logged = true
    }
  }
  return logged
}

export const adminLogout = () => {
  localStorage.removeItem('admin')
  localStorage.removeItem('user') // Also clear user if it was set for admin
  sessionStorage.removeItem('admin-active')
  sessionStorage.removeItem('active')
  window.location.href = `${getSiteBaseURL()}/admin/login`
}
